import { Select } from "antd";
import { useMemo } from "react";
import { addUnique } from "../../helper/checkUnique";

function FilterWomanProducts({
  productsFull,
  paramsFilterUser,
  setParamsFilterUser,
}) {
  const safeProducts = productsFull || [];

  const brands = useMemo(() => {
    const arr = [];
    safeProducts.forEach((p) => p.name && addUnique(arr, p.name));
    return arr;
  }, [safeProducts]);

  const sizes = useMemo(() => {
    const arr = [];
    safeProducts.forEach((p) => p.size && addUnique(arr, p.size));
    return arr;
  }, [safeProducts]);

  const colors = useMemo(() => {
    const arr = [];
    safeProducts.forEach((p) => p.color && addUnique(arr, p.color));
    return arr;
  }, [safeProducts]);

  const conditions = [
    "Mới",
    "Đã sử dụng - Tuyệt vời",
    "Đã sử dụng - Tốt",
    "Đã sử dụng - Trung bình",
  ];

  return (
    <div className="filter-products">
      <div className="filter-products-left">
        <Select
          allowClear
          style={{ width: 170 }}
          options={brands.map((b) => ({ value: b, label: b }))}
          placeholder="Thương hiệu"
          onChange={(value) =>
            setParamsFilterUser((prev) => ({ ...prev, name: value || "" }))
          }
        />
        <Select
          allowClear
          style={{ width: 70 }}
          options={sizes.map((s) => ({ value: s, label: s }))}
          placeholder="Size"
          onChange={(value) =>
            setParamsFilterUser((prev) => ({ ...prev, size: value || "" }))
          }
        />
        <Select
          allowClear
          style={{ width: 120 }}
          options={colors.map((c) => ({ value: c, label: c }))}
          placeholder="Màu sắc"
          onChange={(value) =>
            setParamsFilterUser((prev) => ({ ...prev, color: value || "" }))
          }
        />
        <Select
          allowClear
          style={{ width: 200 }}
          options={conditions.map((c) => ({ value: c, label: c }))}
          placeholder="Tình trạng"
          onChange={(value) =>
            setParamsFilterUser((prev) => ({ ...prev, condition: value || "" }))
          }
        />
      </div>

      <div className="filter-products-right">
        <Select
          allowClear
          style={{ width: 170 }}
          placeholder="Sắp xếp"
          options={[
            { value: "cao-den-thap", label: "Giá: Cao đến Thấp" },
            { value: "thap-den-cao", label: "Giá: Thấp đến Cao" },
          ]}
          onChange={(value) =>
            setParamsFilterUser((prev) => ({ ...prev, priceSort: value || "" }))
          }
        />
      </div>
    </div>
  );
}

export default FilterWomanProducts;
